<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.tahapanSeleksiPelamar }}</strong>
          </p>
        </template>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <td class="flex">
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Atur Tahap Seleksi'"
                    v-b-modal.modal-input-tahapan
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="(data = item), (edit = !edit)"
                    ><CIcon name="cil-settings"
                  /></b-button>
                  <b-button variant="info" class="mr-1" v-c-tooltip.hover.click="'Detail'" v-b-modal.modal-detail @click="(data = item), (detail = !detail)"><CIcon name="cil-info" /></b-button>
                  <b-button
                    variant="success"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Terima Sebagai Karyawan'"
                    v-b-modal.modal-terima
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="(data = item), (terima = !terima)"
                    ><CIcon name="cil-check"
                  /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input-panggilan :data="data" :tahapan="tahapan" :edit="edit" @alertFromChild="triggerAlert($event), getDatas()" @refresh="refresh($event)" />
    <modal-detail :data="data" :detail="detail" />
    <modal-terima :dataPelamar="data" :terima="terima" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInputPanggilan from "./modalInput.vue";
import modalDetail from "./modalDetail.vue";
import modalTerima from "./modalTerima.vue";

export default {
  components: {
    modalInputPanggilan,
    modalDetail,
    modalTerima,
  },
  name: "tahapanSeleksiPelamar",
  data() {
    return {
      edit: null,
      detail: null,
      terima: null,
      data: {},
      tahapan: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1rem;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaPengirim",
          label: "Nama Pelamar",
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatPengirim",
          label: "Alamat",
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "emailPengirim",
          label: "Email",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaLoker",
          label: "Lowongan",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaPosisi",
          label: "Posisi Pelamar",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "min-width: 10%;",
          class: "table-option-4 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    if (this.$store.state.role_aktif.kodeRole == "super") {
      this.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    this.getDatas();
    this.getTahapan();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPelamar = await vm.$axios.post("/postLoker/listByStatusPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        statusPostLoker: 2,
      });
      // console.log("listPelamar", listPelamar);
      vm.items =
        listPelamar.data.status == 200
          ? listPelamar.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.postLokerId,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
      vm.totalRows = Number(listPelamar.data.count);
      vm.loading = false;
    },
    async getTahapan() {
      let vm = this;
      let listTahapan = await vm.$axios.post("masterTahapan/list");
      vm.tahapan = listTahapan.data.status == 200 ? listTahapan.data.data : [];
      // console.log('listTahapan', listTahapan)
    },
    refresh(event) {
      let vm = this;
      if (event.statusNya == 2) {
        vm.showing = true;
        vm.variant = "warning";
        vm.msg = "BERHASIL MENGUPDATE DATA";
        vm.getDatas();
        setTimeout(() => {
          vm.showing = false;
        }, 4000);
      }
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
